import * as React from "react";

interface MediaQueryContextType {
  max_w_1024: boolean;
  min_w_1280: boolean;
}

export function useInitMediaQueryContext(): MediaQueryContextType {
  const q_max_1024 = window.matchMedia("(max-width: 1024px)");
  const q_min_1280 = window.matchMedia("(min-width: 1280px)");

  const [max_w_1024, setMaxW1024] = React.useState(false);
  const [min_w_1280, setMinW1280] = React.useState(false);

  React.useEffect(() => {
    q_max_1024.addEventListener("change", function () {
      checkQueryMatchMax1024();
    });
    checkQueryMatchMax1024();

    q_min_1280.addEventListener("change", function () {
      checkQueryMatchMin1280();
    });
    checkQueryMatchMin1280();
  }, []);

  function checkQueryMatchMax1024() {
    setMaxW1024(q_max_1024.matches);
  }

  function checkQueryMatchMin1280() {
    setMinW1280(q_min_1280.matches);
  }

  return { max_w_1024, min_w_1280 };
}

export const MediaQueryContext = React.createContext<MediaQueryContextType>(null as any);

export function useMediaQuerycontext() {
  return React.useContext(MediaQueryContext);
}
